"use client";

import { QuerySelect } from "@/components/query-select";
import { useUpdateQuery } from "@/hooks/use-update-query";
import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

import { HorizontalTab } from "ui/core/horizontal-tab";

import { MarginTransactionsType, Period } from "../../types/shared";
import { getMarginTransactionsPeriodOptions } from "../helpers/margin-transactions-period-options";
import { getMarginTransactionsTabOptions } from "../helpers/margin-transactions-tab-options";

export const MarginTransactionsControlPanel = ({
  lang,
  period,
  type,
}: {
  lang: Lang;
  period: Period;
  type: MarginTransactionsType;
}) => {
  const { t } = getTranslations(lang);
  const tabOptions = getMarginTransactionsTabOptions({ t });
  const periodOptions = getMarginTransactionsPeriodOptions({ t });

  const { updateQuery } = useUpdateQuery();
  const onTabChange = (key: string) => {
    updateQuery({ name: "margin-transactions-type", value: key });
  };

  return (
    <div className="space-y-5">
      <HorizontalTab
        tabs={tabOptions}
        activeKey={type}
        onTabClick={onTabChange}
        className="justify-between [&>button]:w-full"
      />
      <QuerySelect
        options={periodOptions}
        defaultLabel={periodOptions.find((opt) => opt.value === period)?.label}
        queryName="margin-transactions-period"
        className="max-w-[180px]"
      />
    </div>
  );
};
